import script from "./Attainment.vue?vue&type=script&setup=true&lang=js"
export * from "./Attainment.vue?vue&type=script&setup=true&lang=js"

import "./Attainment.vue?vue&type=style&index=0&id=73798e86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73798e86"]])

export default __exports__